import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { ApiContext } from '../components/ApiProvider';
import TourOperatorLogo from './TourOperatorLogo';
import { useTheme } from '@mui/material/styles';

const styles = (theme) => ({
    logo: {
        marginRight: '8px',
        height: '30px',
        width: '30px',
    },
    brand: {
        color: theme.palette.primary.main,
        display: { xs: 'none', lg: 'block' },
    },
});

export const TourOperatorBrand = ({ operator = null, settings = null, showOnMobile = false, larger = false }) => {
    const theme = useTheme();
    const context = React.useContext(ApiContext);
    
    const actualOperator = operator || context?.tourOperator;
    const actualSettings = settings || context?.settings;
    
    const logoSize = larger ? 60 : 30;
    const logoStyles = {
        ...styles(theme).logo,
        height: `${logoSize}px`,
        width: `${logoSize}px`,
    };
    
    const brandStyles = showOnMobile 
        ? { ...styles(theme).brand, display: 'block' }
        : styles(theme).brand;
    
    const typographyVariant = larger ? 'h4' : 'h6';
    
    const hasOperator = actualOperator?.name && actualOperator?.logo;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: hasOperator ? 'flex-start' : 'center' }}>
            {hasOperator && (
                <Box alt={actualOperator?.name} sx={logoStyles}>
                    <TourOperatorLogo operator={actualOperator} settings={actualSettings} size={logoSize} />
                </Box>
            )}
            <Box>
                <Typography variant={typographyVariant} sx={brandStyles}>
                    {actualOperator?.name || 'Curated Planet'}
                </Typography>
            </Box>
        </Box>
    );
}